export const routes = {
    home: '/',
    playerLevelReport: '/player-level-report',
    transactionHistory: '/transaction-history',
    agents: '/agents',
    revenueShareHistory: '/revenue-share-history',
    players: '/players',
    playerDetails: '/player-details',
    agentDetails: '/agent-details',
    agentLevelReportWeekly: '/agent-level-report-weekly',
    playerLevelReportShare: '/player-level-report/share',
    playerLevelReportPoker: '/player-level-report/poker',
    playerLevelReportPokerNhleSd: '/player-level-report/poker_nlhe_sd',
    playerLevelReportPokerMtt: '/player-level-report/poker_mtt',
    playerLevelReportPokerPlo: '/player-level-report/poker_plo',
    playerLevelReportCasino: '/player-level-report/casino',
    playerLevelReportGlobalSpins: '/player-level-report/global_spins',
    playerLevelReportSports: '/player-level-report/sports',
    playerLevelReportBasic: '/player-level-report/basic',
    playerLevelReportPlayerActivity: '/player-level-report/player_activity',
    playerLevelReportPlayerEcology: '/player-level-report/player_ecology',
    playerLevelReportAll: '/player-level-report/all',
    payoutReport: '/payout-report',
    negativeCarryoverReport: '/negative-carryover-report',
    debtResponsibleMasterAgents: '/debt-responsible-master-agents',
    agentLevelReportDaily: '/agent-level-report-daily',
    countryLevelPartnerReportGameRevenue: '/country-level-partner-report/game-revenue',
    countryLevelPartnerReportUserActivity: '/country-level-partner-report/user-activity',
    countryLevelPartnerReportDepositActivity: '/country-level-partner-report/deposit-activity',
    debtTransferLogs: '/debt-transfer-logs',
    repaymentLogs: '/repayment-logs',
    keycloakLogs: '/keycloak-logs',
    userManagement: '/user-management',
    playerEcologyWeekly: '/player-ecology-weekly',
    referralLinkConfig: '/referral-link-config',
} as const satisfies Record<string, string>;

export type Routes = (typeof routes)[keyof typeof routes];
